import AppCollectionView from './Collection/View.vue';
import AppCollectionQueryViewTrigger from './Collection/QueryViewTrigger.vue';
import AppCollectionFilterTrigger from './Collection/filter/Trigger.vue';

export default {
    AppCollectionView,
    AppCollectionQueryViewTrigger,
    AppCollectionFilterTrigger,
}
